module.exports = __webpack_public_path__ + "static/img/tab1.773eb4fa.png";